import { Collapse, CollapsePanel } from 'components/Collapse';
import { useTypeSafeTranslation } from 'hooks';
import { Trans } from 'next-i18next';
import React, { FC } from 'react';
import styles from './ProgramDetail.module.less';

const ProgramDetail: FC = () => {
  const { t } = useTypeSafeTranslation();
  return (
    <div className={styles.root}>
      <h1>{t('referral.other.program_detail')}</h1>
      <img className={styles.angleLeft} src="/images/campaign/polygon_blur.png" alt="decor" />
      <img className={styles.angleRight} src="/images/campaign/polygon_blur.png" alt="decor" />
      <div className={styles.collapse}>
        <Collapse defaultActiveKey={['1', '2', '3', '4']}>
          <CollapsePanel header="APY is the world's highest standard" key="1">
            <ul className="mb-0 pl-0 ml-8">
              <li>Top 10 APY 8.5%</li>
              <li>Non Top 10 APY 6.67%</li>
            </ul>
          </CollapsePanel>
          <CollapsePanel header="Supporting auto-compounding" key="2">
            <div>
              There is an ON-OFF switch to accommodate ORBS staking auto compound. ORBS staking rewards are
              automatically re-staked once each week. Auto compound occurs every Monday.
            </div>
          </CollapsePanel>
          <CollapsePanel header="No hassle, 0 fees for bridging to Polygon chain with us!" key="3">
            <div>
              Orbs deposits and withdrawals can be made on either the Ethereum or Polygon chains.
              <br /> <br />
              *Staking is done automatically on the Polygon chain. (If you deposit ORBS ERC20 tokens, we will take care
              of the complexity and fees for bridging your tokens to the Polygon chain).
            </div>
          </CollapsePanel>

          <CollapsePanel header="Orbs unstake mechanism" key="4">
            <div>
              If you want to send ORBS that are currently staked, you need to unstake them first. Unstaking will take
              approximately 14 days for the tokens to be transferable, so please verify and prepare in advance.
            </div>
          </CollapsePanel>

          <CollapsePanel header="Reminder" key="5">
            <div>
              For detailed rules and conditions regarding the staking service, please verify the application page at the
              start of the service before applying.
            </div>
          </CollapsePanel>
        </Collapse>
      </div>
    </div>
  );
};

export default ProgramDetail;
